import { ReactNode } from 'react';
import { useCallback } from 'react';
import { FormatOptionLabelMeta } from 'react-select/dist/declarations/src/Select';
import { FacetBadgeLabel } from './FacetBadgeLabel';

interface IOption {
    value: any;
    label: any;
    matches?: number;

    [k: string]: any;
}

interface FormatOptionLabel<Option> {
    (
        data: Option,
        formatOptionLabelMeta: FormatOptionLabelMeta<Option>
    ): ReactNode;
}

export const useMatchesLabel = <
    Option extends IOption
>(): FormatOptionLabel<Option> => {
    return useCallback(
        (value, { context }) => (
            <FacetBadgeLabel
                value={value.matches || 0}
                hideZero
                dark={context === 'value'}
            >
                {value.label}
            </FacetBadgeLabel>
        ),
        []
    );
};
